import cn from 'classnames';
import { ElementPlacementUnion } from 'constants/routes';
import { useSelect } from 'hooks/useSelect';
import { ISelectOption } from 'interfaces';

import OptionsList from 'components/ui/Select/OptionsList';

import { LineTextSelectField } from './LineTextSelectField';

interface LineTextSelectProps<T, P> {
  title: string;
  value: T | T[];
  options: ISelectOption<T, P>[];
  placeholder?: string;
  unknownOptionPlaceholder?: string;
  withSearch?: boolean;
  classNames?: {
    container?: string;
    options?: string;
  };
  onSelect: (value: T, option: ISelectOption<T, P>) => void;
  isMultiple?: boolean;
  menuPlacement?: ElementPlacementUnion;
}

export const LineTextSelect = <T, P>({
  title,
  value,
  options,
  placeholder,
  unknownOptionPlaceholder,
  withSearch,
  classNames,
  onSelect,
  isMultiple,
  menuPlacement,
}: LineTextSelectProps<T, P>) => {
  const {
    containerRef,
    isOpen,
    selectedOptionLabel,
    handleIsOpenToggle,
    handleSelect,
  } = useSelect<T, P, HTMLDivElement>({
    value,
    options,
    placeholder,
    unknownOptionPlaceholder,
    onSelect,
    isMultiple,
  });

  return (
    <div ref={containerRef} className={cn('relative', classNames?.container)}>
      <LineTextSelectField
        title={title}
        value={selectedOptionLabel}
        onClick={handleIsOpenToggle}
      />
      {isOpen && (
        <OptionsList<T, P>
          value={value}
          options={options}
          withSearch={!!withSearch}
          handleClick={handleSelect}
          isAddMode={false}
          isExpandable={true}
          isLoading={false}
          withEmpty={false}
          className={cn(
            { '!top-5': menuPlacement === 'bottom' },
            classNames?.options
          )}
          isMultiple={isMultiple}
          menuPlacement={menuPlacement}
        />
      )}
    </div>
  );
};
